import { api } from "..";

import { QueryProps } from "@/types/Api";
import { Settings } from "@/types/Settings";

export const getSettings = async (
  props: QueryProps<void>
): Promise<Settings> => {
  const res = await api.client.get("/settings", {
    signal: props.signal,
  });
  return res.data;
};
